import { Box } from '@mui/material';
import { KitButton } from '../common/MobileKit';
import { KitField, KitFormBar, KitGrid2, KitSeg, KitTextarea } from '../common/MobileKitExtras';
import FkField, { FkInlineLink } from '../common/MobileFormFields';

/**
 * Formulário de veículo no shell mobile — `prototipos-mobile/veiculos/form.html`.
 * Só apresentação: valores, validação (Yup/Formik), fabricantes, cliente e envio vêm de
 * `pages/vehicles/Form.js`.
 */

const VEHICLE_TYPES = [
    { value: 'car', label: 'Carro' },
    { value: 'motorcycle', label: 'Moto' },
    { value: 'bicycle', label: 'Bicicleta' },
];

export default function MobileVehicleForm({
    formik,
    customers,
    manufacturers,
    loadingManufacturers,
    onChangeType,
    onChangePlate,
    onNewCustomer,
    onManageManufacturers,
    onCancel,
    loading,
}) {
    const { values } = formik;
    const isBicycle = values.type === 'bicycle';
    const typeError = (formik.touched.type && formik.errors.type) || '';
    const observationError = (formik.touched.observation && formik.errors.observation) || '';

    return (
        <Box sx={{ fontSize: 14, lineHeight: 1.4 }} component="form" onSubmit={formik.handleSubmit} noValidate>
            <KitField label="Tipo de veículo" required help={typeError || undefined} error={Boolean(typeError)}>
                <KitSeg options={VEHICLE_TYPES} value={values.type} onChange={onChangeType} />
            </KitField>

            {!isBicycle && (
                <FkField
                    formik={formik}
                    name="license_plate"
                    label="Placa"
                    required
                    type="text"
                    placeholder="ABC-1D23"
                    onChange={onChangePlate}
                    maxLength={8}
                    autoCapitalize="characters"
                    sx={{ textTransform: 'uppercase' }}
                />
            )}

            <FkField formik={formik} name="customer_id" label="Cliente" required as="select">
                <option value="">Selecione</option>
                {customers.map((customer) => <option key={customer.id} value={customer.id}>{customer.name}</option>)}
            </FkField>
            <Box sx={{ mt: '-8px', mb: '14px' }}>
                <FkInlineLink label="Novo cliente" onClick={onNewCustomer} />
            </Box>

            <KitGrid2>
                <Box>
                    <FkField
                        formik={formik}
                        name="manufacturer_id"
                        label="Montadora"
                        required
                        as="select"
                        disabled={!values.type || loadingManufacturers}
                        help={!values.type ? 'Selecione o tipo primeiro' : undefined}
                    >
                        <option value="">{loadingManufacturers ? 'Carregando…' : 'Selecione'}</option>
                        {manufacturers.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
                    </FkField>
                </Box>
                <FkField formik={formik} name="model" label="Modelo" required type="text" disabled={!values.manufacturer_id} />
            </KitGrid2>
            <Box sx={{ mt: '-8px', mb: '14px' }}>
                <FkInlineLink label="Gerenciar montadoras" onClick={onManageManufacturers} />
            </Box>

            <KitGrid2>
                <FkField formik={formik} name="fab_year" label="Ano fabricação" required type="text" inputMode="numeric" maxLength={4} />
                <FkField formik={formik} name="mod_year" label="Ano modelo" required type="text" inputMode="numeric" maxLength={4} />
            </KitGrid2>
            <KitGrid2>
                <FkField formik={formik} name="color" label="Cor" required type="text" />
                <FkField formik={formik} name="kilometer" label="KM" type="text" inputMode="numeric" />
            </KitGrid2>

            <FkField
                formik={formik}
                name="chassi"
                label={isBicycle ? 'SN (Serial Number)' : 'Chassi'}
                required
                type="text"
                maxLength={isBicycle ? undefined : 17}
                autoCapitalize="characters"
                sx={{ textTransform: 'uppercase' }}
            />

            <KitField label="Observações" help={observationError || undefined} error={Boolean(observationError)}>
                <KitTextarea
                    name="observation"
                    value={values.observation}
                    onChange={formik.handleChange}
                    maxLength={500}
                    sx={observationError ? { borderColor: 'error.main' } : undefined}
                />
            </KitField>

            <KitFormBar>
                <KitButton onClick={onCancel}>Cancelar</KitButton>
                <KitButton variant="primary" onClick={formik.handleSubmit} disabled={loading}>
                    {loading ? 'Salvando...' : 'Salvar'}
                </KitButton>
            </KitFormBar>
        </Box>
    );
}
